<div class="font-bold mb-3" i18n>
  Sequence number, SQN is an input to the network authentication algorithm. SQN plays an important role in preventing a replay attack by
  synchronizing the authentication attempts between the secure element (e.g., eSIM) and the wireless core network. 3GPP TS 33.102 defines
  three types of sequence number management profiles - party time-based, not time-based, and entirely time-based.
</div>
<div class="font-bold mb-3" i18n>Pleace select the following SQN options according to your AuC configuration.</div>
<div class="ml-6">
  <div [ngStyle]="{ visibility: errorFound ? 'visible' : 'hidden' }" class="mt-5" style="color: var(--rs-red)">
    <i class="mr-2 pi pi-times-circle"></i>
    <span>{{ errorMessage }}</span>
  </div>
  <table style="border-collapse: separate; border-spacing: 0 20px">
    <tr>
      <td>
        <span class="mr-6 font-bold" i18n>Anonymity Key:</span>
      </td>
      <td>
        <p-radioButton
          (onClick)="handleFormEvents()"
          name="networkAuthentication.sqnOptions.anonymityKey"
          inputId="networkAuthentication.sqnOptions.anonymityKey#0"
          value="0"
          [(ngModel)]="profileValues.networkAuthentication.sqnOptions.anonymityKey"
        ></p-radioButton>
      </td>
      <td>
        <label class="ml-2 mr-6 label-clickable" for="networkAuthentication.sqnOptions.anonymityKey#0" i18n>not used</label>
      </td>
      <td>
        <p-radioButton
          (onClick)="handleFormEvents()"
          name="networkAuthentication.sqnOptions.anonymityKey"
          inputId="networkAuthentication.sqnOptions.anonymityKey#1"
          value="1"
          [(ngModel)]="profileValues.networkAuthentication.sqnOptions.anonymityKey"
        ></p-radioButton>
      </td>
      <td>
        <label class="ml-2 mr-6 label-clickable" for="networkAuthentication.sqnOptions.anonymityKey#1" i18n>used</label>
      </td>
    </tr>
    <tr>
      <td>
        <span class="mr-6 font-bold" i18n>SQN Wrap Around:</span>
      </td>
      <td>
        <p-radioButton
          (onClick)="handleFormEvents()"
          name="networkAuthentication.sqnOptions.sqnWrapAround"
          inputId="networkAuthentication.sqnOptions.sqnWrapAround#0"
          value="0"
          [(ngModel)]="profileValues.networkAuthentication.sqnOptions.sqnWrapAround"
        ></p-radioButton>
      </td>
      <td>
        <label class="ml-2 mr-6 label-clickable" for="networkAuthentication.sqnOptions.sqnWrapAround#0" i18n>not allowed</label>
      </td>
      <td>
        <p-radioButton
          (onClick)="handleFormEvents()"
          name="networkAuthentication.sqnOptions.sqnWrapAround"
          inputId="networkAuthentication.sqnOptions.sqnWrapAround#1"
          value="1"
          [(ngModel)]="profileValues.networkAuthentication.sqnOptions.sqnWrapAround"
        ></p-radioButton>
      </td>
      <td>
        <label class="ml-2 mr-6 label-clickable" for="networkAuthentication.sqnOptions.sqnWrapAround#1" i18n>allowed</label>
      </td>
    </tr>
    <tr>
      <td>
        <span class="mr-6 font-bold" i18n>SQN Delta:</span>
      </td>
      <td>
        <p-radioButton
          (onClick)="handleFormEvents()"
          name="networkAuthentication.sqnOptions.sqnDelta"
          inputId="networkAuthentication.sqnOptions.sqnDelta#0"
          value="0"
          [(ngModel)]="profileValues.networkAuthentication.sqnOptions.sqnDelta"
        ></p-radioButton>
      </td>
      <td>
        <label class="ml-2 mr-6 label-clickable" for="networkAuthentication.sqnOptions.sqnDelta#0" i18n>not used</label>
      </td>
      <td>
        <p-radioButton
          (onClick)="handleFormEvents()"
          name="networkAuthentication.sqnOptions.sqnDelta"
          inputId="networkAuthentication.sqnOptions.sqnDelta#1"
          value="1"
          [(ngModel)]="profileValues.networkAuthentication.sqnOptions.sqnDelta"
        ></p-radioButton>
      </td>
      <td>
        <label class="ml-2 mr-6 label-clickable" for="networkAuthentication.sqnOptions.sqnDelta#1" i18n>used</label>
      </td>
    </tr>
    <tr *ngIf="+profileValues.networkAuthentication.sqnOptions.sqnDelta === 1">
      <td colspan="5">
        <table>
          <tr>
            <td style="width: 250px">
              <span class="ml-3" i18n>Enter the value of sqnDelta</span>
            </td>
            <td>
              <input
                pInputText
                rsHexOnlyInput
                class="maximize-inputs console-text"
                [(ngModel)]="profileValues.networkAuthentication.sqnOptions.sqnDeltaValue"
                [maxlength]="12"
                (input)="handleFormEvents()"
              />
            </td>
          </tr>
        </table>
      </td>
    </tr>
    <tr>
      <td>
        <span class="mr-6 font-bold" i18n>SQN Age Limit:</span>
      </td>
      <td>
        <p-radioButton
          (onClick)="handleFormEvents()"
          name="networkAuthentication.sqnOptions.sqnAgeLimit"
          inputId="networkAuthentication.sqnOptions.sqnAgeLimit#0"
          value="0"
          [(ngModel)]="profileValues.networkAuthentication.sqnOptions.sqnAgeLimit"
        ></p-radioButton>
      </td>
      <td>
        <label class="ml-2 mr-6 label-clickable" for="networkAuthentication.sqnOptions.sqnAgeLimit#0" i18n>not used</label>
      </td>
      <td>
        <p-radioButton
          (onClick)="handleFormEvents()"
          name="networkAuthentication.sqnOptions.sqnAgeLimit"
          inputId="networkAuthentication.sqnOptions.sqnAgeLimit#1"
          value="1"
          [(ngModel)]="profileValues.networkAuthentication.sqnOptions.sqnAgeLimit"
        ></p-radioButton>
      </td>
      <td>
        <label class="ml-2 mr-6 label-clickable" for="networkAuthentication.sqnOptions.sqnAgeLimit#1" i18n>used</label>
      </td>
    </tr>
    <tr *ngIf="+profileValues.networkAuthentication.sqnOptions.sqnAgeLimit === 1">
      <td colspan="5">
        <table>
          <tr>
            <td style="width: 250px">
              <span class="ml-3" i18n>Enter the value of sqnAgeLimit</span>
            </td>
            <td>
              <input
                pInputText
                rsHexOnlyInput
                class="maximize-inputs console-text"
                [(ngModel)]="profileValues.networkAuthentication.sqnOptions.sqnAgeLimitValue"
                [maxlength]="12"
                (input)="handleFormEvents()"
              />
            </td>
          </tr>
        </table>
      </td>
    </tr>
  </table>
</div>
